import { IoMdClose } from "react-icons/io";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { getStockOrderStores } from "../slices/get-store.slice";
import { createQueryParams } from "features/config/helpers";
import { selectedStoreModel } from "features/stock-ordering/core/domain/store-and-category.model";
import { adminSettingsEditUserMaterialSupplierCustomer } from "features/admin/presentation/slices/admin-settings-edit-user-meterial-supplier-customer.slice";
import { PlaceOrderInputWizard } from "../components/place-order-input-wizard";
import { ShoppingCart } from "lucide-react";
import { selectModalScroll } from "../slices/modalScrollSlice.slice";

interface PlaceOrdersModalProps {
  open: boolean;
  onClose: () => void;
  openConfirmationState: (value: boolean) => void;
}

export function PlaceOrderModal(props: PlaceOrdersModalProps) {
  const dispatch = useAppDispatch();

  const modalScrollState = useAppSelector(selectModalScroll);

  const [selectedStore, setSelectedStore] = useState<selectedStoreModel>({
    store_id: "",
    name: "",
    franchise_type_id: "",
  });

  useEffect(() => {
    if (props.open) {
      dispatch(
        getStockOrderStores(
          createQueryParams({
            store_id: selectedStore.store_id ?? "",
          })
        )
      );
      dispatch(adminSettingsEditUserMaterialSupplierCustomer());
    }
  }, [dispatch, selectedStore, props.open]);

  if (props.open) {
    document.body.classList.add("overflow-hidden");
  } else {
    document.body.classList.remove("overflow-hidden");
    return null;
  }

  return (
    <>
      <div
        id="place-order-modal"
        className={`fixed inset-0 z-50 flex items-start justify-center ${
          modalScrollState.status === false &&
          "overflow-auto bg-black/60 backdrop-blur-sm"
        }`}
      >
        <div className="w-[97%] max-w-6xl my-8 bg-white rounded-2xl shadow-2xl border border-gray-200">
          {/* Modern Header */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-700 rounded-t-2xl flex items-center justify-between p-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/20 rounded-lg">
                <ShoppingCart className="h-6 w-6 text-white" />
              </div>
              <h1 className="text-2xl font-bold text-white">Place Order</h1>
            </div>
            <button
              className="p-2 hover:bg-white/20 rounded-lg transition-colors duration-200"
              onClick={() => {
                document.body.classList.remove("overflow-hidden");
                props.onClose();
              }}
            >
              <IoMdClose className="h-6 w-6 text-white" />
            </button>
          </div>

          {/* Content */}
          <div>
            <PlaceOrderInputWizard
              openConfirmationState={() => {
                document.body.classList.remove("overflow-hidden");
                props.onClose();
                props.openConfirmationState(true);
              }}
              setSelectedStore={(selectedStoreData) =>
                setSelectedStore(selectedStoreData)
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
